export const getHostname = (url: string | null | undefined): string | undefined => {
  let urlObject;
  try {
    urlObject = url ? new URL(url) : null;
    return urlObject?.hostname;
  } catch (e) {
    return undefined;
  }
};
